/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InputSmallLabel/view.blocks to change it.
import "DesignSystem/Fonts/Inter-500.module.css"
import Input from 'DesignSystem/Input/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function InputSmallLabel({
  children,
  viewPath = "/DesignSystem/InputSmallLabel",
  marginTop = 0,
  marginRight = 8,
  marginLeft = 0,
  marginBottom = 0,
  label = "Label",
  marginLeftLabel = 10,
  autoFocus,
  autoCapitalize,
  disabled,
  invalidMessage,
  isInvalid,
  paddingBottom = 7,
  paddingLeft = 8,
  paddingRight = 8,
  paddingTop = 7,
  onBlur,
  onChange,
  onFocus,
  onSubmit,
  placeholder,
  type = "text",
  value,
  width = "auto",
  backgroundColor
  
}) {
  return (<React.Fragment
>
<div
  data-testid="InputSmallLabel.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1ffURV': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-2-Z1ffURV': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-3-Z1ffURV': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mb-4-Z1ffURV': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="InputSmallLabel.Text"
  data-view-path={viewPath}
 style={{'--ml-3-Z1ffURV': typeof marginLeftLabel === 'number' ? `${marginLeftLabel}px` : marginLeftLabel}}
 className={`views-text ${styles.Text}`}
>
{label}
</span>
<Input
  viewPath={`${viewPath}/Input`}
 autoFocus={autoFocus}
 autoCapitalize={autoCapitalize}
 disabled={disabled}
 fontSize={14}
 invalidMessage={invalidMessage}
 isInvalid={isInvalid}
 paddingBottom={paddingBottom}
 paddingLeft={paddingLeft}
 paddingRight={paddingRight}
 paddingTop={paddingTop}
 borderBottomLeftRadius={8}
 borderBottomRightRadius={8}
 borderTopLeftRadius={8}
 borderTopRightRadius={8}
 onBlur={onBlur}
 onChange={onChange}
 onFocus={onFocus}
 onSubmit={onSubmit}
 placeholder={placeholder}
 type={type}
 value={value}
 width={width}
 backgroundColor={backgroundColor}
/>
</div>
{children}
</React.Fragment>)
}